import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
import getEnv from '@/utils/env'



var domain = window.location.origin;
if (domain.endsWith("/")) {
  domain = domain.substring(0, domain.length - 1);
}
const state= {
  userLogin: null,
  isMobile: false,
  isTablet: false
};
const getters = {
  userProfile(state){
    return state.userLogin
  },
  isMobile(state){
    return state.isMobile
  },
  isTablet(state){
    return state.isTablet
  }
};

const actions = {
  [actionType.USER_PROFILE]: function({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.get(`/users/me`, {
        headers: {
          'Content-Type':'application/json'
        },
      }).then(result => {
          if(result.data.data) {
            commit(mutationType.SET_USER_PROFILE, result.data.data)
            localStorage.setItem('user_profile', JSON.stringify(result.data.data))
            let showOverlay = localStorage.getItem("first_time_login");
            //
            if (showOverlay==null) {
              localStorage.setItem('first_time_login', JSON.stringify({ id: result.data.data.id, show_overlay: true }))
            }
          }
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  [actionType.USER_LOGOUT]: function({ commit}){
    return new Promise((resolve, reject) => { 
      resolve(localStorage.removeItem('user_profile'));
    })
  },
  [actionType.UPLOAD_AVARTA_USER]: function({ commit},data){
    return new Promise((resolve, reject) => {
      api.put(`/user/profile-image`, data,{
         headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      ).then(result => {
        resolve(result)
        })
        .catch(error => reject(error));
    });
  },
  ["USER_REGISTER"]: function ({ commit, dispatch}, locale) {
    let SSO = window.open(`${getEnv('VUE_APP_THAIRATH_URL_MEMBER')}/v1.0/oauth/authorize?response_type=code&client_id=5e95d097a432f376c8de83f8&redirect_uri=${domain}&scope=photo+offline_access&state=ztDSDB0tkQnfhBTA&register=true`, "_blank", "width=400,height=800")
    let checkCode = setInterval(() => {
      if(SSO.closed){
        clearInterval(checkCode);
      }
      const user_profile = localStorage.getItem('user_profile')
      if(user_profile){
        clearInterval(checkCode);
        SSO.close();
        commit(mutationType.USER_LOGIN_SUCCESS);
      }
    }, 1000);
  }
};

const mutations = {
  [mutationType.SET_USER_PROFILE](state, data) {
    state.userLogin = data;
  },
  UPDATE_IS_MOBILE(state, isMobile) {
    state.isMobile = isMobile
  },
  UPDATE_IS_TABLET(state, isTablet){
    state.isTablet = isTablet
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}